import 'babel-polyfill'
import Vue from 'vue';
import App from '@/App.vue';
import Vuex from 'vuex';
import router from '@/router';
import { store } from '@/store';
import VueMeta from 'vue-meta';
import * as VueGoogleMaps from 'vue2-google-maps'
import { logged } from '@/services/user'
import axios from 'axios'
import '@fortawesome/fontawesome-free/css/all.css'

if (logged()) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
}

Vue.use([
  Vuex,
  VueMeta, {
    refreshOnceOnNavigation: true
  },
]);

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCza_ELpdMvrpnFpZr33xfL8sMyMsX55mM',
        libraries: 'places',
    },
})

Vue.config.productionTip = false

new Vue({
  components: { App },
  router,
  store,
  template: '<App/>',
}).$mount('#app');
